var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ui-dialog',_vm._g(_vm._b({staticClass:"mm-dialog--built-in"},'ui-dialog',_vm.dialogProps,false),_vm.dialogListeners),[_vm._t("default",function(){return [_c('div',{staticClass:"mm-dialog-confirm"},[(_vm.type)?_c('type-icon',{attrs:{"type":_vm.type}}):_vm._e(),_c('message',{attrs:{"is-html":_vm.messageIsHtml,"content":_vm.message}})],1)]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }